export const camelCaseToReadable = (str: string): string => {
	return str
		.replace(/([A-Z])/g, " $1")
		.replace(/^./, (char) => char.toUpperCase())
		.trim();
};
